import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getLlmConfig } from "@/api/audit";

export function DashboardPage() {
  const { data: config } = useQuery({
    queryKey: ["llmConfig"],
    queryFn: getLlmConfig,
  });

  return (
    <div>
      <div className="page-header">
        <h1>Dashboard</h1>
        <p className="page-sub">
          AI-native billing audit for veterinary practices. Find missing charges before the day ends.
        </p>
      </div>

      <div className="card">
        <h2>How it works</h2>
        <ol style={{ color: "var(--text-secondary)", paddingLeft: 20, lineHeight: 1.8 }}>
          <li>
            <strong style={{ color: "var(--text)" }}>Ingest</strong> — paste SOAP notes and the invoice.
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Extract</strong> — the{" "}
            <strong style={{ color: "var(--text)" }}>AI Engine</strong>{" "}
            identifies every billable event from the notes.
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Reconcile</strong> — the engine matches events to
            invoice items and flags discrepancies.
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Review</strong> — one click adds a missed charge
            back to the invoice.
          </li>
        </ol>
      </div>

      <div className="card">
        <h2>Quick actions</h2>
        <div className="row" style={{ marginTop: 12 }}>
          <Link to="/audit" className="btn btn-primary">
            Run a new audit
          </Link>
          <Link to="/leakage" className="btn">
            View leakage summary
          </Link>
        </div>
      </div>

      <div className="card">
        <h2>Model configuration</h2>
        {config ? (
          <div>
            <p style={{ color: "var(--text-secondary)", marginBottom: 12 }}>
              This instance is configured to use the active model via the configured LLM provider.
            </p>
            <p className="muted" style={{ fontSize: "0.9rem", lineHeight: 1.6 }}>
              To change LLM settings, adjust the environment variables in your <code className="mono">.env</code> file:
            </p>
            <ul style={{ color: "var(--text-secondary)", paddingLeft: 20, fontSize: "0.9rem", marginTop: 8, lineHeight: 1.6 }}>
              <li>
                Set <span className="mono">LLM_PROVIDER</span> to <span className="mono">"anthropic"</span>, <span className="mono">"openai"</span>, or <span className="mono">"gemini"</span>
              </li>
              <li>
                Configure the active model name via <span className="mono">ANTHROPIC_MODEL</span>, <span className="mono">OPENAI_MODEL</span>, or <span className="mono">GEMINI_MODEL</span>
              </li>
              <li>
                Provide the corresponding API key under <span className="mono">ANTHROPIC_API_KEY</span>, <span className="mono">OPENAI_API_KEY</span>, or <span className="mono">GEMINI_API_KEY</span>
              </li>
            </ul>
          </div>
        ) : (
          <p className="muted">Loading configuration…</p>
        )}
      </div>
    </div>
  );
}
